import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  Button,
  CircularProgress
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Capacitor } from '@capacitor/core';
import { SignInWithApple } from '@capacitor-community/apple-sign-in';
import { toast } from 'react-toastify';
import IconToast from '../../../components/NewToast';
import { Browser } from '@capacitor/browser';
import { withRouter } from 'react-router';

const AppleLoginButton = ({ intl, history, loginUser, loginPhase, loginMessage, userDetails, disabled }) => {
  const [loading, setLoading] = useState(false);
  const pendingAppleLogin = useRef(false);
  const prevLoginPhase = useRef(loginPhase);
  const appleIdTokenRef = useRef(null);
  const theme = useTheme();

  useEffect(() => {
    const prev = prevLoginPhase.current;
    prevLoginPhase.current = loginPhase;

    if (!pendingAppleLogin.current) return;

    if (loginPhase === false && prev !== false) {
      pendingAppleLogin.current = false;
      if (Capacitor.getPlatform() === 'ios') {
        toast.info(IconToast('error', intl.formatMessage({ id: 'no-portfoplus-account-bound-please-contact-us' })), { className: 'new-toast' });
      } else if (loginMessage === 'apple-not-bound') {
        const params = new URLSearchParams({ campaignCode: 'apple' });
        if (userDetails?.email) {
          params.set('email', userDetails.email);
        }
        if (userDetails?.emailToken) {
          params.set('emailToken', userDetails.emailToken);
        }
        if (Capacitor.isNativePlatform()) {
          params.set('source', 'capacitor');
        }
        history.push(`/userType?${params.toString()}`);
      }
      setLoading(false);
    }

    if (loginPhase === true && prev !== true) {
      pendingAppleLogin.current = false;
      setLoading(false);
    }
  }, [loginPhase, loginMessage, userDetails]);

  const handleAppleLogin = useCallback(async () => {
    setLoading(true);

    try {
      const isWeb = Capacitor.getPlatform() === 'web';
      const result = await SignInWithApple.authorize({
        clientId: isWeb ? 'com.portfoplus.web' : 'com.portfoplus.PortfoPlus',
        redirectURI: `${process.env.PFPLUS_URL}/login`,
        scopes: 'email name'
      });

      const { identityToken } = result.response;
      if (!identityToken) {
        toast.info(IconToast('error', intl.formatMessage({ id: 'apple-authentication-failed' })), {
          className: 'new-toast'
        });
        setLoading(false);
        return;
      }

      pendingAppleLogin.current = true;
      appleIdTokenRef.current = identityToken;
      loginUser({ appleIdToken: identityToken });
    } catch (error) {
      console.error('Apple login error:', error);
      setLoading(false);
    }
  }, [intl, loginUser]);

  if (Capacitor.getPlatform() === 'android') {
    return null;
  }

  return (
    <>
      <Button
        onClick={handleAppleLogin}
        disabled={disabled || loading}
        style={{ minWidth: 'unset', padding: 6, borderRadius: '50%' }}
      >
        {loading ? (
          <div style={{ width: 30, height: 30, borderRadius: '50%', backgroundColor: '#000000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress size={20} style={{ color: '#FFFFFF' }} />
          </div>
        ) : (
          <img src="/img/apple-logo.svg" alt="Apple" style={{ width: 30, height: 30 }} />
        )}
      </Button>
    </>
  );
};

export default withRouter(AppleLoginButton);
